import CharacterLimit from '../CharacterLimit';

import defaultStyles from '../../styles/formSetStyles.module.css';

const DEFAULT_TEXT_INPUT_MAX_LENGTH = 1000;

interface Props {
  id?: string;
  className?: string;
  placeholder?: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
  value?: string;
  characterLimit?: number | null;
  useDefaultMaxLength?: boolean; // only visual, doesn't prevent additional typing
}

export function TextAreaInput(props: Props) {
  const {
    id,
    className,
    placeholder,
    saveFieldValue,
    updateFieldValue,
    value,
    characterLimit,
    useDefaultMaxLength,
  } = props;
  return (
    <div>
      <div className={defaultStyles.InputWrapper}>
        <textarea
          id={id}
          className={className}
          placeholder={placeholder || undefined}
          value={value || ''}
          onChange={(event: React.FormEvent<HTMLTextAreaElement>) =>
            updateFieldValue(event.currentTarget.value)
          }
          onBlur={(event: React.FormEvent<HTMLTextAreaElement>) =>
            saveFieldValue(event.currentTarget.value)
          }
          maxLength={
            characterLimit ??
            (useDefaultMaxLength ? DEFAULT_TEXT_INPUT_MAX_LENGTH : undefined)
          }
        />
      </div>
      {(characterLimit || useDefaultMaxLength) && (
        <CharacterLimit
          currentLength={value?.length || 0}
          limit={characterLimit ?? DEFAULT_TEXT_INPUT_MAX_LENGTH}
        ></CharacterLimit>
      )}
    </div>
  );
}
